import { useSelector } from "react-redux"
import { Stack, Typography, Box } from "@mui/material"
import kedyAICat from "../../../assets/image/home/kedy-ai-cat.svg"
import aiSummaryImage from "../../../assets/image/home/ai-summary.png"
import aiDubbing from "../../../assets/image/home/ai-dubbing.png"
import aiViral from "../../../assets/image/home/ai-viral.png"

import styles from './Discover.module.scss'

export const Discover = () => {

    const languageStrs = useSelector((store) => store.editdata.languageStrs)

    return (
        <Stack alignItems={"center"}>
            <Box display={"flex"} alignItems={"center"} gap={1} justifyContent={"center"}>
                <img width={"7%"} src={kedyAICat} />

                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        fontSize: { xs: '0.8rem', sm: '1.5rem', md: '2rem', lg: '3rem', xl: '3.5rem' },
                        fontWeight: 600,
                        marginBlock: '0.3rem',
                    }}
                >
                    {languageStrs.discover_kedy}
                </Typography>
            </Box>

            <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexDirection={{ xs: "column", md: 'row' }}
                width={"80%"}
                marginTop={6}
            >
                <Box
                    component={"img"}
                    width={{ xs: "80%", sm: '60%', md: '34%' }}
                    src={aiSummaryImage}
                    marginBottom={{ xs: '1rem', md: 0 }}
                />

                <Box maxWidth={{ xs: '34ch', sm: '40ch', md: '50ch', lg: '60ch', xl: '80ch' }}>
                    <Typography sx={{
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                    }}>
                        {languageStrs.create_video_summaries}
                    </Typography>
                    <Typography sx={{
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        opacity: 0.7,
                        textAlign: "justify"
                    }}>
                        {languageStrs.video_summary_description}
                    </Typography>
                </Box>
            </Box>

            <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexDirection={{ xs: "column-reverse", md: 'row' }}
                width={"80%"}
                marginTop={6}
            >
                <Box maxWidth={{ xs: '34ch', sm: '40ch', md: '50ch', lg: '60ch', xl: '80ch' }}>
                    <Typography sx={{
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                    }}>
                        {languageStrs.ai_video_dubbing}
                    </Typography>
                    <Typography sx={{
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        opacity: 0.7,
                        textAlign: "justify"
                    }}>
                        {languageStrs.ai_video_dubbing_description}
                    </Typography>
                </Box>

                <Box
                    component={"img"}
                    width={{ xs: "80%", sm: '60%', md: '34%' }}
                    src={aiDubbing}
                    marginBottom={{ xs: '1rem', md: 0 }}
                />
            </Box>

            <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexDirection={{ xs: "column", md: 'row' }}
                width={"80%"}
                marginBlock={6}
            >
                <Box
                    component={"img"}
                    width={{ xs: "80%", sm: '60%', md: '34%' }}
                    src={aiViral}
                    marginBottom={{ xs: '1rem', md: 0 }}
                />

                <Box maxWidth={{ xs: '34ch', sm: '40ch', md: '50ch', lg: '60ch', xl: '80ch' }}>
                    <Typography sx={{
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                    }}>
                        {languageStrs.viral_clips}
                    </Typography>
                    <Typography sx={{
                        fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        opacity: 0.7,
                        textAlign: "justify"
                    }}>
                        {languageStrs.viral_clips_description}
                    </Typography>
                </Box>
            </Box>
        </Stack>
    )
}

export default Discover